module.exports = __webpack_public_path__ + "static/media/8.06f714ab.jpg";